module.exports = __webpack_public_path__ + "static/media/3.question.460d8565.mp4";